import { render, staticRenderFns } from "./InputColorPicker.vue?vue&type=template&id=3c3bc086&scoped=true"
import script from "./InputColorPicker.vue?vue&type=script&lang=js"
export * from "./InputColorPicker.vue?vue&type=script&lang=js"
import style0 from "./InputColorPicker.vue?vue&type=style&index=0&id=3c3bc086&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3bc086",
  null
  
)

export default component.exports